export function searchSubstitut(array_principal: any[], array_pesquisa: any[]) {
    array_pesquisa.forEach((object_pesquisa, index) => {
        const object_principal = array_principal.find(object => object.id === object_pesquisa.id);
        
        if (object_principal) {
            array_pesquisa[index] = object_principal;
        }
    });
    return array_pesquisa;
}